import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IContainerWidgetPropsType from "./IContainer";
import "../../../assets/sass/widgets/container.scss";
import constantFile from "../../constants/constantFile";
import DeleteIcon from "../../components/DeleteIcon";
import * as draftListActionCreators from "../../components/DraftRegistration/actionCreators";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import * as globalActionCreators from "../../globalStore/actions";
import { handleEnter, valueResolver, checkForPriceChanges, checkForReadOnlyChild, imagePathurl } from "../../utils/utils";
import { fetchAPI } from "../../utils/service";
import endpoints, { endpointTypes } from "../../service";

interface IContainerWidgetStateProps {
    error?: any;
}

/**
 * @class Container
 * @description
 * This component acts as the parent container for group of elements and this is used for groping the components like
 * text box , checkbox and show it in one section
 * @category Wrapper
 */
class ContainerWidget extends React.Component<IContainerWidgetPropsType, IContainerWidgetStateProps> {
    constructor(props) {
        super(props);
        this.state = {
            error: { error: false, errorMessage: [] },
        };
        this.onTrashIconClick = this.onTrashIconClick.bind(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const { deletePopupContent: oldDeletePopupContent } = prevProps;
        const { deletePopupContent: newDeletePopupContent, id, children } = this.props;
        if (
            oldDeletePopupContent.showPopup !== newDeletePopupContent.showPopup &&
            oldDeletePopupContent.confirm !== newDeletePopupContent.confirm
        ) {
            this.deleteAddendum(newDeletePopupContent.dataInfo);
        }
        if (this.props.errorDetails && this.props.errorDetails[id]) {
            if (children && children[0] && children[0].props && children[0].props.formData) {
                const formData = children[0].props.formData;
                this.isDataExist = false;
                this.isValueExist(formData);
                if (this.isDataExist) this.props.dynamicFormActions.removeFieldIdFromStore(id);
            }
        }
    }
    isValueExist = (data) => {
        for (const property in data) {
            if (data.hasOwnProperty(property)) {
                if (typeof data[property] == "object" && !Array.isArray(data[property])) {
                    this.isValueExist(data[property]);
                } else if (Array.isArray(data[property])) {
                    if (data[property].length > 0) {
                        this.isDataExist = true;
                    }
                } else if (data[property]) {
                    this.isDataExist = true;
                }
            }
        }
    };
    isDataExist = false;
    checkForPrice = () => {
        const { errorSchema } = this.props;
        const id = this.props.id.split("_");
        const fieldName = this.props.id.split("_")[id.length - 1];
        const dataValidatorPath =
            errorSchema && errorSchema.length && errorSchema.filter((key) => key.key === fieldName);
        const priceCheck =
            dataValidatorPath.length > 0 &&
            dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");
        let reqObject;
        for (const i in JSON.parse(priceCheck[0].value)) {
            reqObject = {
                ...reqObject,
                [i]: valueResolver(this.props.formData, JSON.parse(priceCheck[0].value)[i].trim()),
            };
        }
        if (priceCheck.length > 0) {
            const requestobject = {
                data: reqObject,
                warrantyId: this.props.warrantyId,
            };
            const successCallBackEditCheck = async () => {
                const formLayoutRoute = endpoints[endpointTypes.FORMLAYOUT];
                const editableCheckEndpoint = formLayoutRoute.endpoints.checkEditable(requestobject);
                try {
                    const response = await fetchAPI(editableCheckEndpoint);
                    return response;
                } catch (err) {
                    this.setState({
                        error: { error: true, errorMessage: [priceCheck[0].message] },
                    });
                    this.props.dynamicFormActions.apiRunningStatus(false);
                    this.props.globalErrorActions.showGlobalError(err);
                }
            };
            return successCallBackEditCheck();
        }
    };

    async onTrashIconClick(deleteId) {
        const { errorSchema, schema, isSubmittedForm } = this.props;
        if (!checkForReadOnlyChild(schema, isSubmittedForm)){
            const id = this.props.id.split("_");
            const fieldName = this.props.id.split("_")[id.length - 1];
            const dataValidatorPath =
                errorSchema && errorSchema.length && errorSchema.filter((key) => key.key === fieldName);
            const priceCheck =
                dataValidatorPath.length > 0 &&
                dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");
            if (priceCheck && priceCheck.length > 0 && checkForPriceChanges(schema.const, isSubmittedForm)) {
                const response = await this.checkForPrice();
                if (response && response.data && response.data.isPriceChanged) {
                    this.setState({ error: { error: true, errorMessage: [priceCheck[0].message] } });
                } else {
                    const object = {
                        title: constantFile.deleteGeneralTitle,
                        description: constantFile.deleteGeneralDescription,
                        buttonText: constantFile.deleteGeneralButtonText,
                        dataInfo: deleteId,
                        showPopup: true,
                        confirm: false,
                        tabIndex: this.props.schema.const.tabIndex,
                    };
                    this.props.draftListActions.updateDeletePopup({ payload: object });
                    document.body.classList.add("hideOverflow");
                }
            } else {
                const object = {
                    title: constantFile.deleteGeneralTitle,
                    description: constantFile.deleteGeneralDescription,
                    buttonText: constantFile.deleteGeneralButtonText,
                    dataInfo: deleteId,
                    showPopup: true,
                    confirm: false,
                    tabIndex: this.props.schema.const.tabIndex,
                };
                this.props.draftListActions.updateDeletePopup({ payload: object });
                document.body.classList.add("hideOverflow");
            }
        }
    }

    deleteAddendum = (className) => {
        const object = {
            title: "",
            description: "",
            buttonText: "",
            dataInfo: "",
            showPopup: false,
            confirm: false,
        };
        this.props.draftListActions.updateDeletePopup({ payload: object });
        const deleteItem: HTMLElement = document.querySelector(".d-none#" + className);
        deleteItem && deleteItem.click();
    };

    render() {
        const { children, schema, classNames, id, isSolarCertified, currFormData } = this.props;
        const isParentId = schema.const && schema.const.optional && schema.const.parent_id;
        const nonSolar = schema.properties ? schema.properties.NonSolarContractorsProducts : null;
        let displayNone = "";
        const getimagePath = imagePathurl();
        if (!isSolarCertified && nonSolar && nonSolar.const && nonSolar.const.checkSolarCertified) {
            const projectDetails =
                currFormData.residentialWarrantyForm && currFormData.residentialWarrantyForm.projectDetails;
            if (
                projectDetails &&
                (projectDetails.warrantyType === "SYSTEM_PLUS" || projectDetails.warrantyType === "SILVER_PLEDGE")
            ) {
                displayNone = "d-none";
            }
        }
        return (
            <div className={`${classNames} ${displayNone}`} data-parentid={isParentId ? schema.const.parent_id : ""}>
                {isParentId && (
                    <div>
                        <span
                            id={`${schema.const.label.replace(/ +/g, "")}_delete_icon`}
                            className="delete-addendum"
                            tabIndex={schema.const.tabIndex}
                            onKeyPress={handleEnter}
                            onClick={() => this.onTrashIconClick(isParentId)}
                        >
                            <DeleteIcon />
                        </span>
                    </div>
                )}
                {children}
                {this.props.errorDetails[id] && this.props.errorDetails[id].length > 0 && (
                    <div className="error-message">
                        {this.props.errorDetails[id] &&
                            this.props.errorDetails[id].map((msg, id) => (
                                <p key={id}>
                                    <img className="ccz-img" src={`${getimagePath}error-field-icon.png`} alt="error" />
                                    &nbsp;
                                    {msg}
                                </p>
                            ))}
                    </div>
                )}
                {this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0 && (
                    <div className="error-message">
                        {this.state.error.errorMessage.map((msg, id) => (
                            <p key={id}>
                                <img className="ccz-img" src={`${getimagePath}error-field-icon.png`} alt="error" />
                                &nbsp;
                                {msg}
                            </p>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    const contractorSettings = state.dynamicFormInfo.contractorSettings || {};
    return {
        deletePopupContent: state.draftListInfo.deletePopup,
        formLayout: state.dynamicFormInfo.layoutResponse,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        formData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        warrantyId: state.dynamicFormInfo.warrantyId,
        isSubmittedForm: state.adminData.isSubmittedForm,
        currFormData: state.dynamicFormInfo.warrantyInfo || {},
        isSolarCertified: contractorSettings.isSolarCertified || false,
    };
}
export const mapDispatchToProps = (dispatch) => {
    return {
        draftListActions: bindActionCreators(draftListActionCreators, dispatch),
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalErrorActions: bindActionCreators(globalActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContainerWidget);
